/*
++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
Este componente ira importar os Cards renderizados no AllCards.js
e irá mostrar no Browser.
++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
*/

import "./CardStyles.css";
import React from 'react';
import handleClick from "./ClickHandler";
import { NavLink } from "react-router-dom";


const BuildCards = (props) => {
  return (
    <div className="card-container">
        <h1 className="events-heading">All Events</h1>
        <div className="events-container">
            {props.data.map((eventos, index) => (
                <div className="events-card" key={ index }>
                    <img src={eventos.image_path} alt="BuildCards"/>
                    <h2 className="event-name">{eventos.name}</h2>
                    <div className="event-description">
                        <p>{eventos.description}</p>
                    <p className="event-datetime"> Data do Evento: {eventos.date} às {eventos.time}</p>
                    <h4 className="event-address"> Local: {eventos.address}</h4>
                        <div className="event-button">
                            <NavLink to="" className="button" onClick={(event) => handleClick(event, eventos.id, eventos.type)}>Buy</NavLink>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
  )
};

export default BuildCards